import { render, staticRenderFns } from "./CustomerGroupsDialog.vue?vue&type=template&id=8c8526f6&"
import script from "./CustomerGroupsDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports